/**
 * Ce fichier permets de zomer sur le dvice choisir dans la map temps reél
 * © Moustapha HENNAWI - Click and Take off - 2021
 */
/*-------------------------------------------------------------------------------------------*/
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { map } from './Map';

/*-------------------------------------------------------------------------------------------*/

export default function SelectedDeviceMap() {
  const mapCenter = useSelector((state) => {
    if (state.devices.selectedId) {
      const position = state.positions.items[state.devices.selectedId] || null;
      if (position) {
        return [position.longitude, position.latitude];
      }
    }
    return null;
  });

  useEffect(() => {
    map.easeTo({ center: mapCenter });
  }, [mapCenter]);

  return null;
}
